module.exports = __webpack_public_path__ + "static/media/iphone_se_starlight.c3ee95de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_se_starlight.png
// module id = 2079
// module chunks = 0